import type { operations } from 'Models/users.api.types';
import type { Untrusted } from 'utils/types';

import Config from 'Config';
import { getWithoutOverride, postWithoutOverride } from 'Redux/api';

type GetMFASettings = operations['getMFAsettings'];
type UpdateMFASettings = operations['updateMFAsettings'];

export const mfaAPI = {
    /** Get the users MFA settings */
    getMFAsettings: async ({ token }: { token: GetMFASettings['parameters']['query']['token'] }) => {
        const url = new URL(`${Config.users_v1_api}/mfa?token=${token}`);
        try {
            const result = await getWithoutOverride(url.toString(), {}, null, true, true);
            return {
                success: true,
                data: (result?.data || {}) as GetMFASettings['responses']['200']['content']['application/json'],
            };
        } catch (err) {
            console.error(err);
            return {
                success: false,
            };
        }
    },
    /** Updates the users MFA settings */
    updateMFASettings: async ({
        token,
        preferredMfaMethod,
    }: {
        token?: UpdateMFASettings['requestBody']['content']['application/json']['token'];
        preferredMfaMethod?: UpdateMFASettings['requestBody']['content']['application/json']['preferredMfaMethod'];
    }) => {
        const url = new URL(`${Config.users_v1_api}/mfa`);
        try {
            const result = await postWithoutOverride(
                url.toString(),
                {
                    token,
                    preferredMfaMethod,
                } as UpdateMFASettings['requestBody']['content']['application/json'],
                null,
                true,
                true
            );
            console.log(result);
            return {
                success: true,
            };
        } catch (error) {
            const err = error as Untrusted;
            console.error(err?.response?.data);
            return {
                success: false,
                data: (err?.response?.data ||
                    {}) as UpdateMFASettings['responses']['400']['content']['application/json'],
            };
        }
    },
};
